import { AuthService as Auth0Service } from '@auth0/auth0-angular';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { inject } from '@angular/core';
import { AuthService } from '@app/features/auth/auth.service';

/**
 * Guard that checks if the user is not logged in.
 */
export function notLoggedInGuard(redirectTo = '/'): CanActivateFn {
  return () => {
    const auth0 = inject(Auth0Service);
    const auth = inject(AuthService);
    const router = inject(Router);
    return auth0.isAuthenticated$.pipe(
      map((isAuthenticated) => isAuthenticated && auth.isAuthenticated()),
      map((isAuthenticated) => (isAuthenticated ? router.createUrlTree([redirectTo]) : true)),
    );
  };
}
